/*
 * @Author: liyingda
 * @Date: 2026-05-25 17:24:47
 * @LastEditors: liyingda
 * @LastEditTime: 2026-05-27 16:20:49
 * @Description: 
 */
import { Request } from '@/utils/request';
import { getCurrentEnvMode } from '@/utils/tools';

const env = getCurrentEnvMode();
// 开户通用接口地址
const kaiHuUrl = {
  dev: '/micro',  // 开发环境直接使用相对路径
  test: '//khtest.10jqka.com.cn/micro',
  release: '//kaihu.10jqka.com.cn/micro',
};

const requestKaiHu = new Request({ baseURL: kaiHuUrl[env] });

export const getRecommendQsListApi = (data: any) => {
  return requestKaiHu.post('/activity/scene/v1/recommend', data);
};
